import { render, staticRenderFns } from "./ConfirmationMessage.vue?vue&type=template&id=d6b1b0ce&scoped=true&"
import script from "./ConfirmationMessage.vue?vue&type=script&lang=js&"
export * from "./ConfirmationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b1b0ce",
  null
  
)

export default component.exports